import styled from "styled-components";

export const Container = styled.div`
  min-height: 117px;
  width: 100%;
  border-radius: 8px;
  padding: 16px;
  margin: 8px 0px;
  background-color: #ffffff;
  /* Neutral Colors/Gray 50 */

  border: 1px solid #ececec;
  border-radius: 8px;
`;

export const Header = styled.div`
  width: 100%;
  display: inline-flex;
  justify-content: space-between;
  margin-bottom: 16px;
`;

export const Title = styled.h2`
  width: calc(100% - 100px);
  font-family: "Inter";
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 19px;
  letter-spacing: -0.01em;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  transform: translateY(5px);
  color: #333333;
`;

export const TitleData = styled.h2`
  font-family: "Inter";
  font-style: normal;
  font-weight: 500;
  font-size: 18px;
  line-height: 21.78px;
  letter-spacing: -0.01em;
  margin-bottom: 16px;

  color: #333333;
`;

export const ButtonContainer = styled.div``;

export const ButtonEdit = styled.button`
  height: 28px;
  width: 28px;
  border-radius: 4px;
  cursor: pointer;
  margin-left: 4px;

  background-color: #eaefff;
`;

export const ButtonConfirm = styled.button`
  height: 28px;
  width: 28px;
  border-radius: 4px;
  padding: 8px;
  cursor: pointer;
  margin-left: 4px;

  background-color: #4caf5033;
`;

export const ButtonArrow = styled.button`
  height: 28px;
  width: 28px;
  border-radius: 4px;
  padding: 8px;
  cursor: pointer;
  margin-left: 4px;

  background-color: transparent;

  .rotate {
    transform: rotate(-90deg);
    transition: 0.5s;
  }
  .not-rotate {
    transform: rotate(0deg);
    transition: 0.5s;
  }
`;

export const Body = styled.a`
  width: 90%;
  height: 32px;
  display: flex;
  text-decoration: none;
  color: rgba(0, 0, 0, 0.87);
  transition: all 0.3s;
  align-items: center;
  border-radius: 8px;
  margin-bottom: 12px;

  &:hover {
    background-color: rgb(224 226 236);
    border-radius: 8px;
    padding-left: 8px;
  }
`;

export const BodyInfo = styled.div`
  width: 90%;
`;

export const Subtitle = styled.p`
  width: 290px;

  font-family: "Inter";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 18px;
  padding-bottom: 5px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

  color: rgba(0, 0, 0, 0.87);
`;

export const SubtitleObs = styled.p`
  width: 95%;
  height: auto;

  font-family: "Inter";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 18px;
  margin-top: 16px;

  color: rgba(0, 0, 0, 0.87);
`;

export const StatusTag = styled.div`
  width: 90%;
  height: 24px;
  align-items: center;
  padding: 1px 16px;
  margin: 0 auto;
  border-radius: 16px;
`;

export const TagText = styled.p`
  font-family: "Inter";
  font-style: normal;
  font-weight: 400;
  font-size: 13px;
  line-height: 16px;
  text-align: center;
  padding-top: 2px;
`;
